export interface DeviceState {
  isSettingDeviceModalOpen: boolean;
  settingDeviceModalView: object;
}
export const initState = () => ({
  isSettingDeviceModalOpen: false,
  settingDeviceModalView: {},
});
const state: DeviceState = initState();

export default state;
